{
  "title": "Datamining",
  "subtitle": "Search and analyse all agent conversations",
  "import_failed": "Import failed",
  "embed_status": "embedding…",
  "loading": "Loading…",
  "no_credentials": "No extension credentials yet.",
  "importing": "importing…",
  "import": "Import",
  "status_active": "Mirror active",
  "status_inactive": "Mirror inactive",
  "live_feed": "Live feed",
  "entries": "entries",
  "loading": "Loading…",
  "empty": "No data yet",
  "not_configured": "HH_PG_MIRROR_DSN not set",
  "tabs": {
    "feed": "Live Feed",
    "search": "Search",
    "sessions": "Sessions",
    "stats": "Token Stats",
    "graph": "Graph"
  },
  "search": {
    "placeholder": "Search term…",
    "filter_type_all": "All types",
    "toggle_semantic": "Semantic",
    "submit": "Search",
    "no_results": "No results",
    "results_count": "{{count}} results",
    "error": "Error: {{message}}"
  },
  "sessions": {
    "title": "Sessions",
    "col_date": "Date",
    "col_agent": "Agent",
    "col_user": "User",
    "col_title": "Title",
    "col_events": "Events",
    "col_status": "Status",
    "no_sessions": "No sessions found"
  },
  "session_detail": {
    "back": "Back",
    "events": "events",
    "untitled": "(untitled)"
  },
  "shell": {
    "running": "Shell…",
    "error": "Shell ✗",
    "button": "Shell history",
    "prompt": "Username for shell history:"
  },
  "graph": {
    "loading": "loading…",
    "load": "Load graph",
    "sessions_with_users": "Sessions with users"
  },
  "stats": {
    "created": "Created",
    "updated": "Updated",
    "messages": "Messages"
  }
}
